import React, { useEffect } from 'react';
import { showSnackBar } from '../../../lib/snackBar';
import { connect } from 'react-redux';
import { setResponseErrorSnack, closeResponseErrorSnack } from '../../../redux/actions/responseError';
import { reportError } from '../../../services/errorReport';

const GlobalSnackbar = (props) => {
    console.log('props in global snackbar', props)

    // Error catalogue (Phase 3): every toast is a display point. reportError resolves the
    // exact message to its catalogue code and is a no-op for anything outside the workbook
    // (success toasts, backend copy — the backend already records its own errors).
    useEffect(() => {
        if (props.snackbarMessage && props.snackbarType !== 'success') {
            reportError(props.snackbarMessage);
        }
    }, [props.snackbarMessage, props.snackbarType]);

    function closeSnackbar() {
        props.closeResponseErrorSnack({ type: "", message: "", hideAfterSec: "" })
    }


    return (
        <div>
            {props.snackbarMessage &&
                showSnackBar({
                    type: props.snackbarType,
                    message: props.snackbarMessage,
                    hideAfterSec: props.snackbarHideAfter,
                    closeSnackbar: () => closeSnackbar()
                })
            }
        </div>
    );
}

const mapStateToProps = (state) => ({
    snackbarType: state.responseError.responseErrorSnack.type,
    snackbarMessage: state.responseError.responseErrorSnack.message,
    snackbarHideAfter: state.responseError.responseErrorSnack.hideAfterSec
})

const mapDispatchToProps = (dispatch) => ({
    setResponseErrorSnack: (payload) => dispatch(setResponseErrorSnack(payload)),
    closeResponseErrorSnack: (payload) => dispatch(closeResponseErrorSnack(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSnackbar);